<template>
  <div class="qrcode">
    <div class="qrBox">
      <div id="reader"></div>
    </div>
  </div>
</template>
<script>
import { Html5Qrcode } from 'html5-qrcode'

// import * as constant from '../../api/constant'
import { Toast, Dialog } from 'vant'
export default {
  created () {

  },
  mounted () {
    this.getCameras()
    Toast.loading({
      message: '请稍后...',
      forbidClick: true
    })
  },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    getCameras () {
      Html5Qrcode.getCameras()
        .then((devices) => {
          if (devices && devices.length) {
            // var cameraId = devices[0].id;
            this.html5QrCode = new Html5Qrcode('reader')
            this.start()
          }
        })
        .catch((err) => {
          console.log('error', err)
          Dialog.alert({
            title: '提示',
            message: err
          }).then(() => {

          })
          // handle err
          this.html5QrCode = new Html5Qrcode('reader')
          this.error = 'ERROR: 您需要授予相机访问权限'
          this.$emit('err', this.error, err)
        })
    },
    start () {
      // environment后置 user前置
      this.html5QrCode
        .start(
          { facingMode: 'environment' },
          {
            fps: 10,
            qrbox: { width: 250, height: 250 }
          },
          (decodedText, decodedResult) => {
            this.$emit('ok', decodedText)
          }
        )
        .catch((err) => {
          this.$emit('err', err)
        })
    },
    stop () {
      this.html5QrCode.stop().then((ignore) => {
        // QR Code scanning is stopped.
        console.log('QR Code scanning stopped.')
      })
        .catch((err) => {
          // Stop failed, handle it.
          console.log('Unable to stop scanning.', err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.qrcode {
  position: absolute;
  height: 100%;
  width: 100%;
  // background: rgba($color: #000000, $alpha: 0.48);
  background: #000;
  overflow-y: hidden;
}

#reader {
  top: 50%;
  left: 0;
  transform: translateY(2.9375rem);
}
</style>
